/* ===========================================================================
   Currency
   =========================================================================== */

$( document ).ready(function() {

// Wait a bit to make sure everything is fully loaded
  /*
  setTimeout(function() {
    function formatNumber(n) {
      // format number 1234567 to 1 234 567
      return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function formatCurrency(input) {
      // get input value
      let input_val = input.val();

      // don't validate empty input
      if (input_val === "") { return; }

      // original length
      let original_len = input_val.length;

      // initial caret position
      let caret_pos = input.prop("selectionStart");

      input_val = formatNumber(input_val);
      input_val = input_val;

      // send updated string to input
      input.val(input_val);

      // put caret back in the right position
      let updated_len = input_val.length;
      caret_pos = updated_len - original_len + caret_pos;
      input[0].setSelectionRange(caret_pos, caret_pos);
    }

    if ($("input.js-vue-price").length) {
    $("input.js-vue-price").on({
      /* keydown: function(e) {
        var key = String.fromCharCode((typeof e.which == "undefined") ? e.keyCode : e.which);
        if (key >= 96 && key <= 105) {
          // Numpad keys
          key -= 48;
        }

        if (!/\d/.test(key) && e.keyCode != 8 && e.keyCode != 46) {
          e.preventDefault();
          return false;
        }
        formatCurrency($(this));
      }, */
  /*
      blur: function() {
        formatCurrency($(this), "blur");
      }
    });
  }

  },1500);*/
});
